(function(){
'use strict';
var text={
 "pastries": [
  "Pastries at Shiro’s",
  "Explore donuts, cookies, cinnamon rolls, croissants and pastries at Shiro’s Bakery & Cafe in downtown Woodland. See the individual items and order through our live menu."
 ],
 "coffee-classics": [
  "Coffee Classics at Shiro’s",
  "Browse espresso drinks, lattes, cappuccinos, cold brew and classic coffee prepared at Shiro’s. See the individual items and order through our live menu."
 ],
 "signatures": [
  "Shiro’s Signatures at Shiro’s",
  "Explore Shiro’s signature café drinks, including specialty coffee and matcha favorites. See the individual items and order through our live menu."
 ],
 "matcha-chai": [
  "Matcha & Chai at Shiro’s",
  "Explore matcha and chai drinks at Shiro’s Bakery & Cafe in downtown Woodland. See the individual items and order through our live menu."
 ],
 "lotus-energy": [
  "Lotus Energy at Shiro’s",
  "Browse our current Lotus Energy menu at Shiro’s Bakery & Cafe. See the individual items and order through our live menu."
 ],
 "lemonades": [
  "Lemonades & Refreshers at Shiro’s",
  "Discover lemonades and refreshing drinks at Shiro’s in Woodland, CA. See the individual items and order through our live menu."
 ],
 "tea-more": [
  "Tea & More at Shiro’s",
  "Discover iced tea, hot tea, hot chocolate and warm café favorites. See the individual items and order through our live menu."
 ],
 "seasonal": [
  "Seasonal Drinks at Shiro’s",
  "Explore Shiro’s current seasonal drinks; availability may change. See the individual items and order through our live menu."
 ],
 "matchas": [
  "Matchas at Shiro’s",
  "Browse matcha lattes and Shiro’s specialty matcha drinks in downtown Woodland."
 ],
 "drinks": [
  "Drinks at Shiro’s",
  "Explore coffee, matcha, tea, lemonades, Lotus Energy and seasonal drinks."
 ],
 "cookies": [
  "Cookies at Shiro’s",
  "Browse today’s Cookies listing under our pastries menu."
 ],
 "coffee": [
  "Coffee at Shiro’s",
  "Explore coffee classics and selected signature drinks."
 ],
 "cakes": [
  "Cakes · Coming Soon",
  "Cakes are not currently listed for online ordering. Visit the live menu for today’s pastries and drinks."
 ]
};
function init(root){
 if(root.dataset.ready==='yes')return;
 root.dataset.ready='yes';
 var p=new URLSearchParams(location.search), forced=root.getAttribute('data-forced-category');
 var category=forced&&forced!=='auto'?forced:p.get('category');
 var handle=forced&&forced!=='auto'?null:p.get('product');
 var onMenu=location.pathname.replace(/\/$/,'').endsWith('/pages/menu');
 if(forced==='auto'&&!category&&!handle)return;
 if(category&&!text[category]&&!handle)return;
 root.hidden=false;
 if(onMenu){
    document.querySelectorAll('#MainContent > .shopify-section').forEach(function(s){if(!s.contains(root))s.style.display='none';});
 }
 var heading=root.querySelector('#ShirosDirectoryHeading'),lead=root.querySelector('#ShirosDirectoryLead'),list=root.querySelector('#ShirosDirectoryList'),detail=root.querySelector('#ShirosDirectoryDetail'),soon=root.querySelector('#ShirosDirectoryComingSoon'),crumb=root.querySelector('#ShirosDirectoryCrumb');
 var items=Array.from(root.querySelectorAll('.shiros-directory__item'));
 if(handle){
   var item=items.find(function(c){return c.dataset.handle===handle;});
   if(!item){heading.textContent='Product not available';lead.textContent='This item is not currently linked to an live menu item. Explore the current menu instead.';list.hidden=true;return;}
   var name=item.dataset.title,groups=item.dataset.groups.split(','),group=groups.find(function(g){return g!=='drinks';})||'drinks';
   heading.textContent=name;lead.textContent='Shiro’s Bakery & Cafe · 422 Main Street, Woodland, CA';
   crumb.textContent=' / '+name;
   list.hidden=true;detail.hidden=false;soon.hidden=true;
   root.querySelector('#ShirosDirectoryDetailTitle').textContent=name;
   var description=item.dataset.description||'';
   description=description.split('Visit Shiro’s Bakery & Cafe at 422 Main Street')[0].replace(/\bAIO\b/g,'our live menu').trim();
   root.querySelector('#ShirosDirectoryDetailDescription').textContent=description;
   root.querySelector('#ShirosDirectoryFaqHeading').textContent='Questions about '+name;
   root.querySelector('#ShirosDirectoryFaqOrderQuestion').textContent='Can I order '+name+' ahead?';
   root.querySelector('#ShirosDirectoryFaqIngredientsQuestion').textContent='What ingredients or allergens are in '+name+'?';
   var img=item.querySelector('img'),target=root.querySelector('#ShirosDirectoryDetailImage');
   target.src=img.currentSrc||img.src;target.alt=img.alt;
   var order=root.querySelector('#ShirosDirectoryOrder');order.href=item.dataset.orderUrl;order.setAttribute('aria-label','Order '+name+' on our live menu');
   root.querySelector('#ShirosDirectoryBack').href='/pages/menu?category='+encodeURIComponent(group);
   document.title=name+' | Shiro’s Bakery & Cafe Woodland, CA';
 }else{
   category=category||'drinks';heading.textContent=text[category][0];lead.textContent=text[category][1];
   crumb.textContent=' / '+text[category][0];document.title=text[category][0]+' | Shiro’s Bakery & Cafe Woodland, CA';
   if(category==='cakes'){list.hidden=true;soon.hidden=false;}else{
     var ct=0;
     items.forEach(function(item){var visible=item.dataset.groups.split(',').indexOf(category)!==-1;item.hidden=!visible;if(visible)ct++;});
     if(ct===0){lead.textContent='No current menu products are available in this category. View the live menu for updates.';}
   }
 }
}
function boot(){document.querySelectorAll('.shiros-directory').forEach(init);}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
document.addEventListener('shopify:section:load',boot);
})();